module.exports = __webpack_public_path__ + "img/0c53610a1bb46e3472bd048a1545c7c5.png";